// @flow
import * as actionTypes from '../constants/action_types'
import * as ids from '../constants/ids'
import { getCookie, setCookie } from '../util/cookies'

export type BookmarkType = {
    ficusNode: string,
    error?: string,
}

export type SelectBookmarkBarType = {
    bookmarksGlobal: BookmarkType[],
    bookmarksLocal: BookmarkType[],
    bookmarksMRU: BookmarkType[],
    hidden: boolean,
    visible: boolean,
}

type SelectBookmarkBarActionType = {
    type: string,
    id: string,
    active?: boolean,
    bookmarks: BookmarkType[],
    bookmarkType: string,
    destBookmarkType: string,
    destBookmarkNode: string,
    ficusNode?: string,
    ficusNodes?: string[],
    srcBookmarkType: string,
    srcBookmarkNode: string,
}

const initialState = {
    bookmarksGlobal: [],
    bookmarksLocal: getCookie('bookmarksLocal') || [],
    bookmarksMRU: getCookie('bookmarksMRU') || [],
    hidden: false,
    visible: true,
}

function BookmarkException(message) {
    this.message = message
    this.name = 'BookmarkException'
}

export default function selectFrameworkBar(state: SelectBookmarkBarType = initialState, action: SelectBookmarkBarActionType) {
    let ret = state
    if (ret.bookmarksMRU === 'undefined') {
        ret.bookmarksMRU = []
        console.warn('bookmarkMRU cookie is set to "undefined"')
    }
    if (action.type === actionTypes.CLICK_CONTEXT_BAR_ITEM) {
        if (action.id === ids.SELECT_BOOKMARK) {
            // Toggle the control bar if clicking an already-active framework button.
            // Otherwise, always show the control bar.
            ret = (action.active
                ? { ...state, visible: !state.visible }
                : { ...state, visible: true })
        }
    } else if (action.type === actionTypes.CLOSE_CONTEXT_BAR_ITEMS) {
        ret = ({ ...state, hidden: state.visible, visible: false })
    } else if (action.type === actionTypes.OPEN_CONTEXT_BAR_ITEMS) {
        ret = { ...state, visible: state.hidden, hidden: false }
    } else if (action.type === actionTypes.ADD_BOOKMARK) {
        const i = state[action.bookmarkType].findIndex(b => b.ficusNode === action.ficusNode)
        if (i === -1) {
            ret = {
                ...state,
                [action.bookmarkType]: [{ ficusNode: action.ficusNode }, ...state[action.bookmarkType]],
            }
        }
    } else if (action.type === actionTypes.ADD_BOOKMARKS) {
        ret = {
            ...state,
            [action.bookmarkType]: action.bookmarks,
        }
    } else if (action.type === actionTypes.REMOVE_BOOKMARK) {
        const i = state[action.bookmarkType].findIndex(b => b.ficusNode === action.ficusNode)
        if (i >= 0) {
            ret = {
                ...state,
                [action.bookmarkType]: [...state[action.bookmarkType].slice(0, i), ...state[action.bookmarkType].slice(i + 1)],
            }
        } else {
            console.warn(`Bookmark ${action.ficusNode} not found in ${action.bookmarkType}`)
        }
    } else if (action.type === actionTypes.MOVE_BOOKMARK) {
        ret = { ...state }

        if (action.destBookmarkType !== 'bookmarksMRU') {
            let j = state[action.srcBookmarkType].findIndex(b => b.ficusNode === action.srcBookmarkNode)
            if (j < 0) {
                throw new BookmarkException(`Cannot find ${action.srcBookmarkNode} in ${action.srcBookmarkType}`)
            }
            const bookmark = state[action.srcBookmarkType][j]
            // Remove bookmark from source list
            // ret[action.srcBookmarkType] = [...ret[action.srcBookmarkType].slice(0, j), ...ret[action.srcBookmarkType].slice(j + 1)]

            // And add it to destination list. Don't add duplicates
            // Currently I am not able to drop it into the beginning of the list unless the parent is chosen (ie, no dest bookmark selected)
            j = ret[action.destBookmarkType].findIndex(b => b.ficusNode === bookmark.ficusNode)
            if (j < 0) {
                // Add in the given position
                j = ret[action.destBookmarkType].findIndex(b => b.ficusNode === action.destBookmarkNode)
                ret[action.destBookmarkType].splice(j + 1, 0, bookmark)
            }
        }
    }

    // Update cache
    setCookie('bookmarksLocal', ret.bookmarksLocal)
    setCookie('bookmarksMRU', ret.bookmarksMRU)

    return ret
}
